import { Base64Util } from "./Base64Util";

export class BlobUtil {
    public static toBlob(data: string | Uint8Array, mimeType: string): Blob {
        const uint8Array = typeof data === "string" ? Base64Util.toUint8Array(data) : data;
        return new Blob([uint8Array], { type: mimeType });
    }
}